import { Async, Loaded, Loading } from 'Core/models/Async';
import { StringUnion } from 'Core/models/EmptyString';

export class UnassignedCaseNumber {
  public static create(caseNumber: StringUnion) {
    return new UnassignedCaseNumber(caseNumber);
  }

  public readonly key = 'UnassignedCaseNumber';
  constructor(public readonly value: StringUnion) { }
}

export class UserAssignedCaseNumber {
  public static create(caseNumber: string) {
    return new UserAssignedCaseNumber(caseNumber);
  }

  public readonly key = 'UserAssignedCaseNumber';
  constructor(public readonly value: string) { }
}

export class CaseNumberError {
  public static create(caseNumber: string) {
    return new CaseNumberError(caseNumber);
  }

  public readonly key = 'CaseNumberError';
  constructor(public readonly value: string) { }
}

export type CaseNumber = Async<string> | UnassignedCaseNumber | UserAssignedCaseNumber | CaseNumberError;

type MatchCaseNumberOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (caseNumber: string) => TReturn;
  Error: () => TReturn;
  Unassigned: (caseNumber: StringUnion) => TReturn;
  UserAssignedCaseNumber: (caseNumber: string) => TReturn;
  CaseNumberError: (caseNumber: string) => TReturn;
};

export const isLoading = (caseNumber: CaseNumber): caseNumber is Loading<string> =>
  caseNumber.key === 'Loading';

export const isLoaded = (caseNumber: CaseNumber): caseNumber is Loaded<string> => caseNumber.key === 'Loaded';

export const isCaseNumberError = (caseNumber: CaseNumber): caseNumber is CaseNumberError =>
  caseNumber.key === 'CaseNumberError';

export const matchCaseNumber = <TReturn>(options: MatchCaseNumberOptions<TReturn>) => (
  caseNumber: CaseNumber
) => {
  switch (caseNumber.key) {
    case 'UnassignedCaseNumber':
      return options.Unassigned(caseNumber.value);
    case 'Loaded':
      return options.Loaded(caseNumber.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
    case 'UserAssignedCaseNumber':
      return options.UserAssignedCaseNumber(caseNumber.value);
    case 'CaseNumberError':
      return options.CaseNumberError(caseNumber.value);
  }
};